<template>
  <v-container fluid grid-list-xl>
    <div>
      <v-data-table
        :headers="columnsDisplayed"
        :items="rows"
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="totalRows"
        :rows-per-page-items="pageCountOptions"
        item-key="id"
        class="elevation-1"
        must-sort
        no-data-text="No data found"
        no-results-text="No results found"
        @update:pagination="search"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="(header) in props.headers"
              :key="header.value"
              v-show="header.visible"
              :class="['font-weight-bold text-xs-left column sortable pa-1 ma-0', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th class="ma-0 pa-0 text-xs-right">
              <v-btn icon flat color="primary" @click="reset">
                <v-icon>fa-refresh</v-icon>
              </v-btn>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <tr>
            <td
              v-for="(header) in columnsDisplayed"
              :key="header.value"
              v-show="header.visible"
              class="ma-0 pa-1"
            >
              <template v-if="header.type === 'datetime'">
                {{ datetime(props.item[header.value]) }}
              </template>

              <template v-else>
                {{ props.item[header.value] }}
              </template>
            </td>

            <td class="ma-0 pa-0 text-xs-right">
              <v-btn round small :to="{ name: 'OkdmvAgency', params: { id: props.item.tracking_id }}">View</v-btn>
              <v-btn round small :to="{ name: 'OkdmvAgencyEdit', params: { id: props.item.tracking_id }}" v-if="environment !== 'production'">Edit</v-btn>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          No results found
        </template>
      </v-data-table>

      <v-layout row wrap justify-end>
        <v-btn color="primary" @click="searchModal = true">Search</v-btn>
        <v-btn @click="exportFull">Export</v-btn>
        <v-btn @click="importAgencies">Import</v-btn>
        <v-btn to="/okdmv/agencies/add">Add One</v-btn>
      </v-layout>
    </div>

    <v-dialog v-model="searchModal" @submit.prevent @keydown.esc.prevent="searchModal=false">
      <v-toolbar dense>
        <v-toolbar-title>Search</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="searchModal = false">
          <v-icon>fa-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <v-form @keyup.native.enter="searchNew">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Agency Name"
                    v-model="filter.name"
                    box
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Agency ID"
                    v-model="filter.tracking_id"
                    box
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-select
                    label="City"
                    v-model="filter.city"
                    :items="cities"
                    multiple
                    box
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-select
                    label="County"
                    v-model="filter.county"
                    :items="counties"
                    multiple
                    box
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Email"
                    v-model="filter.email"
                    box
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Notes"
                    v-model="filter.notes"
                    box
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-menu
                    ref="startDateModal"
                    :close-on-content-click="false"
                    v-model="startDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedStartDate"
                      label="Created Start"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.start_date"
                      no-title
                      @input="$refs.startDateModal.save(filter.start_date)"
                    />
                  </v-menu>
                  <v-menu
                    ref="endDateModal"
                    :close-on-content-click="false"
                    v-model="endDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedEndDate"
                      label="Created End"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.end_date"
                      no-title
                      @input="$refs.endDateModal.save(filter.end_date)"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-divider class="primary"></v-divider>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap justify-end>
                    <v-btn color="primary" @click="searchNew">Search</v-btn>
                    <v-btn @click="reset">Clear</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import ExportMixin from '@/mixins/export'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import ReceiptModal from '@/components/transactions/ReceiptModal.vue'
import RefundModal from '@/components/transactions/RefundModal.vue'
import VoidModal from '@/components/transactions/VoidModal.vue'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, ExportMixin, RecurringMixin, StoreMixin, UtilityMixin],
  components: {ReceiptModal, RefundModal, VoidModal},

  data: function () {
    return {
      cities: [
        'Ada',
        'Altus',
        'Anadarko',
        'Ardmore',
        'Bartlesville',
        'Bethany',
        'Bixby',
        'Blackwell',
        'Blanchard',
        'Broken Arrow',
        'Catoosa',
        'Chickasha',
        'Choctaw',
        'Claremore',
        'Clinton',
        'Collinsville',
        'Coweta',
        'Cushing',
        'Del City',
        'Duncan',
        'Durant',
        'Edmond',
        'El Reno',
        'Elk City',
        'Enid',
        'Glenpool',
        'Grove',
        'Guthrie',
        'Guymon',
        'Harrah',
        'Henryetta',
        'Holdenville',
        'Hugo',
        'Idabel',
        'Jenks',
        'Lawton',
        'Lone Grove',
        'McAlester',
        'Miami',
        'Midwest City',
        'Moore',
        'Muskogee',
        'Mustang',
        'Newcastle',
        'Noble',
        'Norman',
        'Oklahoma City',
        'Okmulgee',
        'Owasso',
        'Pauls Valley',
        'Perry',
        'Piedmont',
        'Ponca City',
        'Poteau',
        'Pryor Creek',
        'Purcell',
        'Sallisaw',
        'Sand Springs',
        'Sapulpa',
        'Seminole',
        'Shawnee',
        'Skiatook',
        'Stillwater',
        'Tahlequah',
        'Tecumseh',
        'The Village',
        'Tulsa',
        'Tuttle',
        'Vinita',
        'Wagoner',
        'Warr Acres',
        'Watonga',
        'Weatherford',
        'Woodward',
        'Yukon'
      ],

      counties: [
        'Adair',
        'Alfalfa',
        'Atoka',
        'Beaver',
        'Beckham',
        'Blaine',
        'Bryan',
        'Caddo',
        'Canadian',
        'Carter',
        'Cherokee',
        'Choctaw',
        'Cimarron',
        'Cleveland',
        'Coal',
        'Comanche',
        'Cotton',
        'Craig',
        'Creek',
        'Custer',
        'Delaware',
        'Dewey',
        'Ellis',
        'Garfield',
        'Garvin',
        'Grady',
        'Grant',
        'Greer',
        'Harmon',
        'Harper',
        'Haskell',
        'Hughes',
        'Jackson',
        'Jefferson',
        'Johnston',
        'Kay',
        'Kingfisher',
        'Kiowa',
        'Latimer',
        'Le Flore',
        'Lincoln',
        'Logan',
        'Love',
        'Major',
        'Marshall',
        'Mayes',
        'McClain',
        'McCurtain',
        'McIntosh',
        'Murray',
        'Muskogee',
        'Noble',
        'Nowata',
        'Okfuskee',
        'Oklahoma',
        'Okmulgee',
        'Osage',
        'Ottawa',
        'Pawnee',
        'Payne',
        'Pittsburg',
        'Pontotoc',
        'Pottawatomie',
        'Pushmataha',
        'Roger Mills',
        'Rogers',
        'Seminole',
        'Sequoyah',
        'Stephens',
        'Texas',
        'Tillman',
        'Tulsa',
        'Wagoner',
        'Washington',
        'Washita',
        'Woods',
        'Woodward'
      ],

      filter: this.defaultFilter(),
      columns: this.defaultColumns(),
      pagination: this.defaultPagination(),
      pageCountOptions: [5, 10, 25, 50, 100],
      loading: false,
      rows: [],
      totalRows: 0,

      searchModal: false,
      startDateModal: false,
      endDateModal: false
    }
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },

    columnsDisplayed: function () {
      return this.columns.filter(column => {
        if (column.value === 'ach_is_authorized' && this.paymentType === 'ach') {
          column.visible = true
        }

        if (column.value === 'card_expiration_yymm' && this.paymentType === 'ach') {
          column.visible = false
        }

        if (column.value === 'terminal_code' && this.terminalsCard.length < 2) {
          column.visible = false
        }

        if (column.value === 'account_name' && this.myProfile.accounts.length < 2) {
          column.visible = false
        }
        if (column.value === 'transactions_source_id' && !this.hasPermission('can_use_hpp')) {
          column.visible = false
        }
        if (this.myProfile.custom && this.myProfile.custom.hasOwnProperty(this.paymentType === 'ach' ? 'transaction_ach_columns' : 'transaction_columns')) {
          if (this.myProfile.custom[this.paymentType === 'ach' ? 'transaction_ach_columns' : 'transaction_columns'].includes(column.value)) {
            column.visible = true
          } else {
            column.visible = false
          }
        }

        if (column.visible) {
          return true
        }

        return false
      }, this)
    },

    columnsExported: function () {
      return this.columns.filter(column => {
        if (column.value === 'ach_is_authorized' && this.paymentType === 'ach') {
          column.export = true
        }

        if (column.value === 'card_expiration_yymm' && this.paymentType === 'ach') {
          column.export = false
        }

        if (column.value === 'terminal_code' && this.terminalsCard.length < 2) {
          column.export = false
        }

        if (column.value === 'account_name' && this.myProfile.accounts.length < 2) {
          column.export = false
        }

        if (this.myProfile.custom && this.myProfile.custom.hasOwnProperty(this.paymentType === 'ach' ? 'transaction_ach_export_columns' : 'transaction_export_columns')) {
          if (this.myProfile.custom[this.paymentType === 'ach' ? 'transaction_ach_export_columns' : 'transaction_export_columns'].includes(column.value)) {
            column.export = true
          } else {
            column.export = false
          }
        }

        if (column.export) {
          return true
        }

        return false
      }, this)
    },

    formattedStartDate () {
      return this.filter.start_date ? Moment(this.filter.start_date).format('MMM-DD-YYYY') : ''
    },
    formattedEndDate () {
      return this.filter.end_date ? Moment(this.filter.end_date).format('MMM-DD-YYYY') : ''
    }
  },

  watch: {
    $route (to, from) {
      this.reset()
    }
  },

  methods: {
    defaultColumns () {
      return [
        {
          value: 'name',
          text: 'Name',
          export: true,
          sortable: true,
          visible: true
        },
        {
          value: 'tracking_id',
          text: 'Agency ID',
          export: true,
          sortable: true,
          visible: true
        },
        {
          value: 'city',
          text: 'City',
          export: true,
          sortable: true,
          visible: true
        },
        {
          value: 'county',
          text: 'County',
          export: true,
          sortable: true,
          visible: true
        },
        {
          value: 'email',
          text: 'Email',
          export: true,
          sortable: true,
          visible: true
        },
        {
          value: 'created',
          text: 'Created',
          export: true,
          sortable: true,
          type: 'datetime',
          visible: true
        }
      ]
    },

    defaultFilter () {
      return {
        name: '',
        tracking_id: '',
        city: '',
        county: '',
        email: '',
        notes: '',
        start_date: '',
        end_date: ''
      }
    },

    defaultPagination () {
      return {
        descending: false,
        page: 1,
        rowsPerPage: this.$store.state.paginationDefaults.rowsPerPage,
        sortBy: 'name'
      }
    },

    reset () {
      this.columns = this.defaultColumns()
      this.filter = this.defaultFilter()
      this.pagination = this.defaultPagination()

      this.search()
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.search()
    },

    searchNew () {
      this.pagination.page = 1
      this.search()
    },

    async search () {
      this.loading = true

      try {
        let filter = { ...this.filter }

        if (filter.start_date) {
          filter.start_date = Moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (filter.end_date) {
          filter.end_date = Moment(Moment(this.filter.end_date).format('YYYY-MM-DD') + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
        }

        let result = await this.api({
          method: 'get',
          url: '/okdmv_agencies',
          params: {
            filter: filter,
            page: this.pagination.page - 1,
            perPage: this.pagination.rowsPerPage,
            orderBy: this.pagination.sortBy,
            orderDirection: this.pagination.descending ? 'desc' : 'asc'
          }
        })
        console.log(result.data)
        this.rows = result.data.rows
        this.totalRows = result.data.count
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        this.searchModal = false
        this.loading = false
      }
    },

    importAgencies () {

    },

    async exportFull () {
      try {
        this.loading = true
        let result = await this.api({
          method: 'get',
          url: '/transactions',
          params: {
            filter: this.filter,
            perPage: '*',
            orderBy: this.pagination.sortBy,
            orderDirection: this.pagination.descending ? 'desc' : 'asc'
          }
        })

        let csvContent = 'data:text/csv;charset=utf-8,'
        let headers = [ ...this.headers ]
        headers.push({
          value: 'customer_po',
          text: 'Customer PO'
        })
        headers.push({
          value: 'custom_field_1',
          text: 'Custom 1'
        })
        headers.push({
          value: 'custom_field_2',
          text: 'Custom 2'
        })
        headers.push({
          value: 'custom_field_3',
          text: 'Custom 3'
        })

        csvContent += [
          headers.map(header => '"' + header.text + '"').join(','),
          ...result.data.rows.map(row => {
            return headers.map(header => {
              let value = row[header.value]
              if (header.value === 'is_recurring') {
                value = (value === 0) ? 'No' : 'Yes'
              }
              if (header.value === 'is_fee_waived') {
                value = (value === 0) ? 'No' : 'Yes'
              }
              if (header.value === 'total_amount') {
                value = '$' + (value / 100).toFixed(2)
              }
              if (value === null) {
                value = ''
              }

              return '"' + ('' + value).replace(/"/, '""') + '"'
            })
              .join(',')
          })

        ]
          .join('\n')

        await this.downloadCSVData(csvContent)

        this.loading = false
      } catch (err) {
        // this.$store.commit('error', err)
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/okdmv/Agencies.vue